import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import "./styles/landing.css";

// Ahoy analytics
import ahoy from "ahoy.js";
ahoy.configure({
  urlPrefix: "",
  visitsUrl: "/ahoy/visits",
  eventsUrl: "/ahoy/events",
  page: null,
  platform: "Web",
  useBeacon: true,
  startOnReady: true,
  trackVisits: true,
  cookies: true,
  cookieDomain: null,
  headers: {},
  visitParams: {},
  withCredentials: false
});

// Track page views automatically
ahoy.trackView();

import React from "react";
import { createRoot } from "react-dom/client";
import VideoForm from "./components/VideoForm";

document.addEventListener("DOMContentLoaded", () => {
  const node = document.getElementById("video-react-root");
  if (!node) return;

  const apiUrl = node.dataset.apiUrl;
  const showBaseUrl = node.dataset.showBaseUrl;
  const authenticityToken = document.querySelector("meta[name='csrf-token']")?.content;
  const isFreeTier = node.dataset.isFreeTier === "true";
  const freeTierMaxDuration = parseInt(node.dataset.freeTierMaxDuration, 10) || 10;

  const root = createRoot(node);
  root.render(
    <React.StrictMode>
      <VideoForm
        apiUrl={apiUrl}
        showBaseUrl={showBaseUrl}
        authenticityToken={authenticityToken}
        isFreeTier={isFreeTier}
        freeTierMaxDuration={freeTierMaxDuration}
      />
    </React.StrictMode>
  );
});
